<template>
<section class="content">
    <div>
      <div class="box-body">
        <div :class="addButtonClass">
          <router-link :to="{ name: 'wasteTypeCreate',params: {_id: '0' } }">
            <button class=" btn gradientbt">Add Waste Type</button>
          </router-link>
        </div>

            <div v-if="updateCategoryDetails" class="">
                <div class="">
                    <div class="">
                        <div class=""></div>
                        <div id="details" class="overlay waste_type_pop">
                            <div class="overlay_inner">
                               
                                <div class="row form-modal">
                                    <vue-form :state="formstate">
                                        <h4 class="text-center">Update {{ this.rows.wCName }}</h4>

                                        <div class="col-sm-12" style="padding-top:15px">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.categoryUpdate)">
                                                <input  maxlength="25" type="text" name="categoryUpdate" class="form-control" v-model="category.categoryUpdate" placeholder="Category (Dry, Wet, E-Waste etc.) " pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}" />
                                                <field-messages name="categoryUpdate" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">
                                                        Category is a required field
                                                    </div>
                                                    <div slot="pattern">
                                                        Alphabets/Numbers are allowed.
                                                    </div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </vue-form>
                                    <div class="form-actions">
                                        <button type="submit" @click="updateWasteType" :disabled="!(formstate.$dirty && formstate.$valid)" v-bind:class="'mr-2 btn gradientbt'">
                                            Update
                                        </button>
                                        <button @click="onClose" v-bind:class="'mr-5  btn btn-default'">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <v-server-table ref="wasteTypeTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                <template slot="beforeBody">
                    <tr v-if="loading" class="VueTables__no-results">
                        <td class="text-center" colspan="6">
                            <pulse-loader></pulse-loader>
                        </td>
                    </tr>
                </template>

                <template slot="wCName" slot-scope="props">
                    <div class="active_wrp" style="display:flex; justify-content:space-between">
                        {{ props.row.wCName }}

                        <a class="fa fa-pencil" style="flex: inherit" role="button" @click.prevent="(e) => editCategory(props.row)"></a>
                    </div>
                </template>

                <template slot="action" slot-scope="props">
                    <div class="active_wrp">
                        <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>

                        <div class="py-2 text-center row">
                            <label class="toggle">
                                <input class="toggle-checkbox" type="checkbox" :checked="props.row.status" @click.prevent="(e) => activateWasteTypeModal(props.row)" />
                                <span class="slider"></span>
                                <span class="labels" data-on="Active" data-off="Deactivate"></span>
                            </label>
                        </div>
                    </div>
                </template>
            </v-server-table>
        </div>
    </div>
</section>
</template>

<script>
import {
    formService,
    eventBus,
    wasteTypeService
} from "../../../services";
import {
    USER_ROLES
} from "../../../config";
import {
    ServerTable,
    Event
} from "vue-tables-2";
import {
    mapState
} from "vuex";
import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";
import dateFormatter from "../../utilities/dateFormate";

export default {
    name: "wasteType",
    wCName: null,

    data() {
        return {
            formstate: {},
            rows: [],
            updateCategoryDetails: false,
            category: {},
            isAreaTable: false,
            subcatdetails: "",
            loading: null,
            USER_ROLES: USER_ROLES,
            wasteTypeTable: null,
            columns: ["wCName", "subCategory", "createdAt", "action"],
            options: {
                highlightMatches: true,
                headings: {
                    wCName: "Category",
                    subCategory: "Sub Category",
                    createdAt: "Created On",
                    action: "Action",
                },
                templates: {
                    createdAt(row, query) {
                        return dateFormatter(query.createdAt);
                        // return moment(query.createdAt).format("DD-MM-YYYY");
                    },
                    subCategory(row, query) {
                        let test = [];
                        for (let i = 0; i < query.subCategory.length; i++) {
                            if (i === query.subCategory.length - 1)
                                test.push(query.subCategory[i].wSubCName);
                            else test.push(query.subCategory[i].wSubCName + ", ");
                        }
                        return test.slice();
                    },
                },
                perPage: 10,
                sortable: ["wCName", "subCategory", "createdAt"],
                requestFunction: (request) => {
                    const params = {
                        // $embed: ['user']
                    };

                    params.page = request.page;
                    params.limit = request.limit;

                    if (request.orderBy) {
                        if (request.orderBy === "subCategory") {
                            params.sortBy = "subCategory.wSubCName";
                        } else {
                            params.sortBy = request.orderBy;
                        }
                        if (request.ascending == 1) {
                            params.sortOrder = "asc";
                        } else {
                            params.sortOrder = "des";
                        }
                    }

                    if (request.query != "") {
                        // if(request.query.length < 3) return;
                        params.searchString = request.query;
                    }
                    this.loading = true;
                    return this.$wastetypeDataRepository
                        .collectionAreaList(params)
                        .catch((error) => {
                            console.error("wasteType.requestFunction-error:", error);
                        });
                },

                responseAdapter: (response) => {
                    let count;
                    this.loading = false;
                    if (response.data.response === 0) {
                        count = 0;
                    }
                    return {
                        data: response.data.response,
                        count: response.data.total || 0,
                    };
                },
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.wasteTypeTable) {
                return this.wasteTypeTable.count > this.wasteTypeTable.limit ||
                    this.wasteTypeTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        fieldClassName: formService.fieldClassName,
        onClose() {
            this.category.categoryUpdate = "";
            this.updateCategoryDetails = false;
        },
        editCategory(row) {
            this.rows["wCName"] = row.wCName;
            this.rows["_id"] = row._id;
            this.rows["status"] = row.status;
            this.updateCategoryDetails = true;
        },
        updateWasteType(row, new_subcat) {
            new_subcat = this.category.categoryUpdate;
            let updateCategory = {
                _id: this.rows._id,
                wCName: new_subcat,
                status: this.rows.status,
            };
            this.loading = true;
            return wasteTypeService
                .updateWasteType(updateCategory, this.oldWasteType)
                .then((response) => {
                    this.loading = false;
                    this.updateCategoryDetails = false;
                    this.category.categoryUpdate = "";
                    this.$refs.wasteTypeTable.refresh();
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.request.status === 409) {
                        this.$snotify.error("Category Already Exist!");
                    } else {
                        this.$snotify.error("Create Failed!", "Error!");
                    }
                });
        },

        activateWasteTypeModal(row) {
            let categoryName = row.wCName;
            let confirmtext;
            if (row.status === true) {
                confirmtext = "Deactivate";
            } else {
                confirmtext = "Activate";
            }
            swal({
                // title: "Are you sure?",
                title: `Are you sure you want to ${confirmtext}?`,
                // text: `Are you sure you want to ${confirmtext}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, ${confirmtext}`,
            }).then((result) => {
                if (result.value) {
                    this.activateWasteType(row);
                }
            });
        },
        activateWasteType(row) {
            let confirmtext;
            if (row.status === true) {
                confirmtext = "Deactive";
            } else {
                confirmtext = "Active";
            }
            this.loading = true;
            let wasteType = {
                wCName: row.wCName,
                status: !row.status,
                _id: row._id,
            };
            return wasteTypeService
                .updateWasteType(wasteType)
                .then((response) => {
                    this.loading = false;
                    row.status = !row.status;
                    this.$snotify.success(
                        `The ${row.wCName} has been marked ${confirmtext}.`
                    );
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("wasteType.activateWasteType-error:", error);
                    this.$snotify.error("Activate wasteType failed", "Error!");
                });
        },
        action(row) {
            this.$router.push({
                name: "wasteTypeCreate",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },
        onLoaded() {
            this.wasteTypeTable = this.$refs.wasteTypeTable;
        },
        clearFilter() {
            this.custom_filter_select = "";
        },
        applyFilter(filter_val) {
            Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
        },
    },
    mounted() {
        eventBus.$on("DATA_PUBLISHED", (payload) => {});
    },
};
</script>

<style>
.overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.sidepop {
    position: fixed;
    width: 600px;
    z-index: 9999;
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    right: 0;
    top: 0;
    height: 100%;
}

.form-modal {
    background: #fff;
    width: 60%;
    padding: 0;
}

.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
    background: #3085d6;
    color: white;
}

.toggle {
    cursor: pointer;
    display: inline-block;
}

.toggle-switch {
    display: inline-block;
    background: #ccc;
    border-radius: 16px;
    width: 48px;
    height: 21px;
    position: relative;
    vertical-align: middle;
    transition: background 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
    content: "";
}

.toggle-switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    width: 15px;
    height: 15px;
    position: absolute;
    top: 3px;
    left: 4px;
    transition: left 0.25s;
}

.active_wrp {
    display: flex;
    align-items: center;
}

.active_wrp a {
    flex: 0 0 30%;
    color: #3085d6;
    margin-right: 5px;
}

.gradientbt:hover {
    color: #3085d6;
    background: #fff;
    border: 2px solid #3085d6;
}

.toggle:hover .toggle-switch:before {
    background: linear-gradient(to bottom, #fff 0%, #fff 100%);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}

.toggle-checkbox:checked+.toggle-switch {
    background: #3085d6;
}

.toggle-checkbox:checked+.toggle-switch:before {
    left: 30px;
}

.toggle-checkbox {
    position: absolute;
    visibility: hidden;
}

.toggle-label {
    margin-left: 5px;
    position: relative;
    top: 2px;
}

/* new css */

.toggle {
    --width: 64px;
    --height: calc(var(--width) / 3);

    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
}

.toggle input {
    display: none;
}

.toggle .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--height);
    background-color: #ccc;
    transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--height));
    height: calc(var(--height));
    border-radius: calc(var(--height) / 2);
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
    background-color: #3085d6;
}

.toggle input:checked+.slider::before {
    transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-family: sans-serif;
    transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
    content: attr(data-off);
    position: absolute;
    right: 5px;
    color: #4d4d4d;
    opacity: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
    content: attr(data-on);
    position: absolute;
    left: 5px;
    color: #ffffff;
    opacity: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
    opacity: 0;
}

.toggle input:checked~.labels::before {
    opacity: 1;
}

.toggle_icon {
    --width: 64px;
    --height: calc(var(--width) / 3);
    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: none;
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: absolute;
    top: 10px;
    right: -15px;
}

.swal2-popup {
    padding: 30px 15px;
}

.toggle_icon svg {
    width: 15px;
    height: 15px;
}

button.swal2-cancel.swal2-styled {
    display: block !important;
}

.swal2-popup .swal2-styled.swal2-confirm {
    background-color: #3085d6 !important;
}

span.VueTables__template {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.overlay_inner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.overlay_inner .form-modal h4 {
    background: #f1f1f1;
    padding: 20px;
    margin: 0;
    border-bottom: 1px solid #ddd;
    text-align: left;
}

.overlay_inner .form-actions {
    text-align: right;
    padding: 20px 15px;
    border-top: 1px solid #ddd;
    display: inline-block;
    width: 100%;
}

.waste_type_pop .form-modal {
    width: 30%;
}
</style>



// WEBPACK FOOTER //
// wasteType.vue?1b1070b5